import { NgModule } from '@angular/core';
import { TableRepository } from './repositories/table.repository';
import { WorkspaceDatabaseProvider } from './workspace-database.provider';
import { ColumnRepository } from './repositories/column.repository';
import { DataRepository, FlatTableDataRepository, ReferenceTableRepository, SamplesRepository } from './repositories';
import {
	DatabaseManagerService,
	DeviceIdProvider,
	DynamicSchemaService,
	PopulateFormFieldsService,
	RefTablesStorageService,
	RestoreDatabaseService,
	RxdbIdProvider
} from './services';
import { MigrationManagerService } from './migration';

@NgModule({
	declarations: [],
	imports: [],
	providers: [
		WorkspaceDatabaseProvider,
		TableRepository,
		ColumnRepository,
		ReferenceTableRepository,
		DataRepository,
		RestoreDatabaseService,
		DynamicSchemaService,
		RxdbIdProvider,
		FlatTableDataRepository,
		PopulateFormFieldsService,
		MigrationManagerService,
		SamplesRepository,
		RefTablesStorageService,
		DatabaseManagerService,
		DeviceIdProvider
	],
	bootstrap: []
})
export class WorkspaceDatabaseModule {}
